import React from 'react';
import type { Project } from '../types/api';

type Props = {
  project: Project;
};

export const ProjectKeys = ({ project }: Props) => (
  <div className="project-keys">
    <div className="project-keys-header">
      <p className="eyebrow">Credential set</p>
      <h3>API keys</h3>
      <p className="card-subtitle">Rotate keys before distributing them downstream.</p>
    </div>
    <dl className="kv-grid">
      <div className="kv">
        <dt>Active</dt>
        <dd>
          <code>{project.active_key}</code>
        </dd>
      </div>
      <div className="kv">
        <dt>Pending</dt>
        <dd>
          <code>{project.pending_key}</code>
        </dd>
      </div>
      <div className="kv">
        <dt>Old (sunset)</dt>
        <dd>
          <code>{project.old_active_key ?? '—'}</code>
        </dd>
      </div>
      <div className="kv">
        <dt>Key expires at</dt>
        <dd>
          <code>{project.key_expires_at ?? '—'}</code>
        </dd>
      </div>
    </dl>
  </div>
);

export default ProjectKeys;

